@use 'sass:map';
@use 'sass:math';

@use '../../scss/utility';
@use '../grey-box/grey-box-vars';

$floating-label-height: map.get(utility.$TEXT_CONFIGS, 's', 'mq1', 'line-height');
$input-text-height: map.get(utility.$TEXT_CONFIGS, 'l', 'mq1', 'line-height');
$input-text-height-s: map.get(utility.$TEXT_CONFIGS, 'm', 'mq1', 'line-height');

:host {
  display: block;

  .wb-grey-box {
    --floating-label-height: #{$floating-label-height};
    --input-text-height: #{$input-text-height};
    --block-remaining-space: calc(var(--grey-box-height) - (var(--floating-label-height) + var(--input-text-height) + var(--grey-box-label-text-gap)));
  }

  .caret-icon {
    position: absolute;
    z-index: 1;
    pointer-events: none;
  }

  .status-icon {
    position: absolute;
    inset-block-start: calc((var(--grey-box-height) - var(--wb-status-badge-size)) / 2);
    pointer-events: none;
    inset-inline-end: 0;
  }
}

:host([size='s']) {
  @include grey-box-vars.wb-grey-box-s-hint-vars;

  .wb-grey-box {
    --input-text-height: #{$input-text-height-s};
  }

  &,
  ::slotted(select) {
    @include utility.wb-text(
      'm',
      (
        responsive: false,
      )
    );
  }
}

:host([size='m']) {
  @include grey-box-vars.wb-grey-box-m-hint-vars;
}

:host([size='l']) {
  @include grey-box-vars.wb-grey-box-l-hint-vars;
}

// Adding !important for padding because there is no other way to override styling from tailwind or any other styling library which applies padding to 0 as initial value.
:host .default-slot-container ::slotted(select) {
  padding-block-start: calc(var(--block-remaining-space) / 2 + var(--floating-label-height)) !important;
  padding-inline-end: calc(var(--grey-box-padding-inline-end) + var(--grey-box-action-size)) !important;
  padding-block-end: calc(var(--block-remaining-space) / 2) !important;
  padding-inline-start: var(--grey-box-padding-inline-start) !important;
}

.label {
  @include grey-box-vars.wb-grey-box-floating-label-vars;
  position: absolute;
  inset-block-start: calc(var(--block-remaining-space) / 2);
  inset-inline: var(--grey-box-padding-inline-start) calc(var(--grey-box-padding-inline-end) + var(--grey-box-action-size));
  @include utility.wb-text(
    's',
    (
      responsive: false,
    )
  );
  cursor: text;
  background-color: inherit;
  color: var(--grey-box-label-color);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  pointer-events: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  z-index: 1;
}

:host,
:host ::slotted(select) {
  @include utility.wb-text(
    'l',
    (
      responsive: false,
    )
  );
  color: inherit;
  outline: none;
  border: none;
  background-color: inherit;
  text-transform: none;
}

:host .default-slot-container {
  color: var(--grey-box-input-color);
  width: 100%;
}

:host(.wb-select) ::slotted(select) {
  box-shadow: inset 0 0 0 var(--grey-box-border-weight) var(--grey-box-border-color);
  background-color: var(--grey-box-background-color);
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

// have to set the color twice to enable color-change in all browsers.
:host([value]:not([value=''])) .default-slot-container {
  color: var(--grey-box-input-color);
}

:host([disabled]) {
  pointer-events: none;
}

:host(:not([filled])) .default-slot-container {
  color: var(--grey-box-label-color);
}

:host([disabled]) ::slotted(select) {
  cursor: not-allowed;
}

:host([active]) .default-slot-container,
::slotted(select:focus) {
  color: var(--grey-box-input-color);
}

$status-width: calc(var(--grey-box-status-padding) + var(--wb-status-badge-size) + var(--grey-box-status-padding) + var(--grey-box-padding-inline-end));

:host([success]),
:host([error]) {
  .label {
    padding-inline-end: $status-width;
  }

  .caret-icon {
    inset-inline-end: $status-width;
  }

  ::slotted(select) {
    padding-inline-end: calc(#{$status-width} + var(--grey-box-action-size)) !important;
  }
}

:host([compact]) {
  display: inline-flex;
  flex-direction: column;
  min-width: utility.wb-pixel-to-rem(144px);

  .label {
    position: absolute;
    opacity: 0;
  }
}

:host([compact]) .default-slot-container ::slotted(select) {
  padding-block: calc((var(--grey-box-height) - var(--input-text-height)) / 2) !important;
}

::slotted(.wb-control-error),
::slotted(.wb-control-hint) {
  margin-inline-start: var(--grey-box-hint-padding-inline-start);
}
